import React, { type FC, useEffect } from 'react'

import Text from 'components/Text'
import { type BaseProps } from 'types'
import styles from './style.scss'
import Fade from 'components/Fade'

export interface Item {
  id: string
  message: string
  duration?: number
  bottomGap?: number
}

export interface SnackbarItemProps extends Item {
  dismiss: (id: string) => void
}

export interface Props extends BaseProps {
  items: Item[]
  duration?: number
  dismiss: (id: string) => void
  bottomGap?: number
}

const SnackbarItem: FC<SnackbarItemProps> = ({ id, message, dismiss, duration }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      dismiss(id)
    }, duration)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <div className={styles['snackbar-item']}>
      <Text className={styles['message']}>{message}</Text>
    </div>
  )
}

const Snackbar: FC<Props> = ({ items, dismiss, bottomGap = 70 }) => {
  return (
    <output
      role='status'
      aria-live='polite'
      className={styles['snackbar']}
      style={{ bottom: `${bottomGap}px` }}
    >
      {Array.isArray(items) &&
        items.map(({ id, message, duration = 3000 }) => (
          // Todo: replace Fade with better animation
          <Fade key={id}>
            <SnackbarItem id={id} message={message} dismiss={dismiss} duration={duration} />
          </Fade>
        ))}
    </output>
  )
}

export default Snackbar
